export default __webpack_public_path__ + "static/media/skill_algorithm.5c9bb6a6.png";